import data from './data/config/routes' //数据中心
import shopData from './shopData/config/routes' //门店数据
import achievement from './achievement/config/routes' //门店业绩
import collectRank from './collectRank/config/routes' //汇总排行
import memberCardTrade from './memberCardTrade/config/routes' //会员卡交易数据
import packCardTrade from './packCardTrade/config/routes' //套餐卡交易数据
import paperCard from './paperCard/config/routes' //纸质套餐录入
// import paperRepair from './paperRepair/config/routes'; //纸质修护卡录入
import shopRecharge from './shopRecharge/config/routes' //充值额度申请
import index from './index/config/routes' // 数据首页
import packages from './packAge/config/routes' // 电子套餐
import reportElectronMember from './reportElectronMember/config/routes' // 电子总账
import performanceTargets from './performanceTargets/config/routes' // 销售目标
import integralAchievement from './integralAchievement/config/routes' // 销售目标
import repairData from './repairData/config/routes' // 档案数据
import dailyBusiness from './dailyBusiness/config/routes' // 营业日报
import yuanYuanAchievement from './yuanYuanAchievement/config/routes'
import productDeposit from './productDeposit/config/routes' // 产品寄存
import staffJournal from './staffJournal/config/routes' // 店员日志
import staffBorrowInfo from './staffBorrowInfo/config/routes' // 店员借领
import attendancePunch from './attendancePunch/config/routes' // 考勤打卡
import abnormalAttendance from './abnormalAttendance/config/routes' // 打卡异常
import attendanceStatistics from './attendanceStatistics/config/routes' // 考勤统计
import salary from './salary/config/routes' // 工资条
import staffSubsidy from './staffSubsidy/config/routes' // 店员补贴
import cookAllowance from './cookAllowance/config/routes' // 厨师补贴
import smsTemplate from './smsTemplate/config/routes' // 客情维护
import staffKPISalary from './staffKPISalary/config/routes' // 店长绩效
import staffPromotion from './staffPromotion/config/routes' // 晋升
import inventory from './inventory/config/routes' // 库存管理
import inventoryWastage from './inventoryWastage/config/routes' // 库存管理
import inventoryBill from './inventoryBill/config/routes' // 出入库记录
import inventoryCheck from './inventoryCheck/config/routes' // 库存盘点
import shopBill from './shopBill/config/routes' // 收支账
import inventoryInquire from './inventoryInquire/config/routes' // 库存查询
import warningPushSetting from './warningPushSetting/config/routes' // 预警推送设置
import authManagement from './authManagement/config/routes' // 权限管理
import memberAnalysis from './memberAnalysis/config/routes' // 会员分析
import memberDataAlert from './memberDataAlert/config/routes' // 会员分析

export default [
	...data,
	...index,
	...packages,
	...achievement,
	...collectRank,
	...memberCardTrade,
	...packCardTrade,
	...paperCard,
	// ...paperRepair,
	...shopRecharge,
	...shopData,
	...reportElectronMember,
	...performanceTargets,
	...integralAchievement,
  ...repairData,
  ...dailyBusiness,
  ...yuanYuanAchievement,
  ...productDeposit,
  ...staffJournal,
  ...staffBorrowInfo,
  ...attendancePunch,
  ...abnormalAttendance,
  ...attendanceStatistics,
  ...salary,
  ...staffSubsidy,
  ...cookAllowance,
  ...smsTemplate,
  ...staffKPISalary,
  ...staffPromotion,
  ...inventory,
  ...inventoryWastage,
  ...inventoryCheck,
  ...inventoryBill,
  ...shopBill,
  ...inventoryInquire,
  ...warningPushSetting,
  ...authManagement,
  ...memberAnalysis,
  ...memberDataAlert
]
